import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * 「その他」カテゴリを選択していてフリーテキストが空のまま次に進もうとした際に
 * 表示する確認ダイアログ。close(true) で「このまま保存」、close(false) で「戻って入力する」。
 */
@Component({
  selector: 'app-confirm-empty-free-text-dialog',
  templateUrl: './confirm-empty-free-text-dialog.component.html',
  styleUrls: ['./confirm-empty-free-text-dialog.component.scss'],
})
export class ConfirmEmptyFreeTextDialogComponent {
  constructor(
    public modalRef: MatDialogRef<ConfirmEmptyFreeTextDialogComponent, boolean>
  ) {}
}
